import { useState } from 'react';
import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { CommonRefund } from 'services/api/return';
import { ButtonProps } from 'antd/es/button';
import ProposeDlg from './ProposeDlg';

interface IProps extends CommonRefund {
  unit: string;
  allowOffer: Conversation.Trade.IAllowOffer[];
  children?: React.ReactNode;
  operationLog: Conversation.Trade.IReturnOperationLog[];
  offerCounterLimit: number;
  displayStatus: Conversation.Trade.IDisplayStatus;
}

/** 提出部分退款; 再次提案; */
const ProposeConsult = (
  props: Omit<ButtonProps, 'onClick'> & IProps & { onSuccess?: () => void },
) => {
  const { t } = useTranslate();
  const {
    externalStoreId,
    returnSn,
    externalTradeId,
    onSuccess,
    unit,
    allowOffer,
    children,
    operationLog,
    offerCounterLimit,
    displayStatus,
    ...btnProps
  } = props;

  const [visible, setVisible] = useState(false);

  const title =
    displayStatus === 'RETURN_PROCESSING' ? t('trade.提出部分退款') : t('trade.再次提案');

  return (
    <>
      <Button
        size="small"
        {...btnProps}
        onClick={() => {
          setVisible(true);
        }}
      >
        {title}
      </Button>
      <ProposeDlg
        unit={unit}
        allowOffer={allowOffer}
        visible={visible}
        setVisible={setVisible}
        returnSn={returnSn}
        onSuccess={onSuccess}
        operationLog={operationLog}
        offerCounterLimit={offerCounterLimit}
        title={title}
      >
        {children}
      </ProposeDlg>
    </>
  );
};

export default ProposeConsult;
